import { useTranslation } from 'react-i18next';
import TVIcon from 'assets/images/screenAndProtect/icons/tv.svg?react';
import FurnitureIcon from 'assets/images/screenAndProtect/icons/furniture.svg?react';
import ClinkingGlassesIcon from 'assets/images/screenAndProtect/icons/clinking-glasses.svg?react';
import PetIcon from 'assets/images/screenAndProtect/icons/pet.svg?react';
import CleanIcon from 'assets/images/screenAndProtect/icons/clean.svg?react';
import {
  ProtectionItems,
  ProtectionItem,
} from './ScreenAndProtectLanding.styles';

const protectionItems = [
  {
    icon: TVIcon,
    key: 'pageScreenAndProtect.landingPage.protection.items.damage',
  },
  {
    icon: FurnitureIcon,
    key: 'pageScreenAndProtect.landingPage.protection.items.smoke',
  },
  {
    icon: ClinkingGlassesIcon,
    key: 'pageScreenAndProtect.landingPage.protection.items.parties',
  },
  {
    icon: PetIcon,
    key: 'pageScreenAndProtect.landingPage.protection.items.animals',
  },
  {
    icon: CleanIcon,
    key: 'pageScreenAndProtect.landingPage.protection.items.cleaning',
  },
] as const;

const LandingProtectionItems = () => {
  const { t } = useTranslation();

  return (
    <ProtectionItems>
      {protectionItems.map(({ icon: Icon, key }) => (
        <ProtectionItem key={key}>
          <Icon />
          <p>{t(key)}</p>
        </ProtectionItem>
      ))}
    </ProtectionItems>
  );
};

export default LandingProtectionItems;
